<div style="float: left;text-align: justify;width: 98%;"
  *ngIf="isVaidUserObjToken=='true' && !showUnauthorizedAccessPage">
  <p [ngClass]="{'hardwareReq':showMore, 'hardwareReq1': !showMore}">
    {{ showMore ? diagnosticHWReq : (diagnosticHWReq | slice: 0:140) }} <span *ngIf="!showMore">...</span>
    <a href="javascript:;" *ngIf="!showMore" (click)="onShow()">Show More</a>
    <a href="javascript:;" *ngIf="showMore" (click)="onShow()">Show Less</a>
  </p>
</div>
<div *ngIf='!fdrsOutOfDate && !showUnauthorizedAccessPage' class="no-print"
  [ngStyle]="{'display': CanShowFDRSIcon ? 'flex' : 'none'}" style="justify-content: flex-end;float:right;width: 2%;">
  <img src="/assets/images/splash.png" alt="FDRS" style="padding: 0 10px; height: 31px; margin-top: 1%;
  padding-right: 0px;float: right;right: 10px;" />
</div>

<div *ngIf='fdrsOutOfDate && !showUnauthorizedAccessPage' class="no-print fdrsoutDate"
  [ngStyle]="{'display': fdrsOutOfDate ? 'right' : 'none'}" style="justify-content: flex-end;float:right;width: 2%;">
  <img src="/assets/images/splash.png" alt="FDRS" style="padding: 0 10px; height: 31px; margin-top: 1%;
  padding-right: 0px;float: right;right: 10px;" />
</div>

<div class="no-print" style="justify-content: flex-end; width: 100%; display: flex; float: right;">
  <img *ngIf="isshowLoader && isVaidUserObjToken=='true' && !showUnauthorizedAccessPage"
    src="assets/images/ajax-loader.gif" width="30" height="30" style="margin-top: 1%;
  padding-right: 0px;">
</div>
<div style="justify-content: flex-end; width: 100%; display: flex; float: right;position: absolute;">
  <p *ngIf="isshowLoader && isVaidUserObjToken=='true' && !showUnauthorizedAccessPage">{{'Connecting to
    GFDRS'|translate}}.....</p>
</div>

<div *ngIf="isVaidUserObjToken == 'false'">
  <p class="invalidToken">{{'invalidToken'|translate}}</p>
</div>
<div *ngIf="isVaidUserObjToken=='true' && !showNavbar">
  <app-startup></app-startup>
</div>
<div *ngIf="showExpiryNotification">
  <app-token-expiry-notification></app-token-expiry-notification>
</div>

<ng-template #FDRSConnectionErrorPopup let-modal>
  <div class="container version">
    <div class="row popup-header">
      <div class="pull-left">{{'Information'|translate}}</div>
      <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
          (click)="modal.dismiss('FDRSConnectionErrorPopup')"></i></div>
    </div>
    <div>
      <label class='msg-body'>{{fdrsConnectionError}}</label>
    </div>
    <hr class="hr-line">
    <div class="popup-footer">
      <button type="button" class="close-btn-popup pull-right" name="cancel"
        (click)="modal.dismiss('FDRSConnectionErrorPopup');">{{'close'|translate}}</button>
    </div>
  </div>
</ng-template>

<ng-template #FDRSVersionPopup let-modal>
  <div class="container version">
    <div class="row popup-header">
      <div class="pull-left">{{'Information'|translate}}</div>
      <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
          (click)="modal.dismiss('FDRSVersionPopup')"></i></div>
    </div>
    <div>
      <!-- FDRS version out of date. Please download and install the latest version -->
      <label class='msg-body'>{{'fdrsVersionOutDatedInfo'|translate}} {{fdrsMinimumVersion}}</label>
    </div>

    <hr class="hr-line">
    <div class="popup-footer">
      <button type="button" class="close-btn-popup pull-right" name="cancel"
        (click)="modal.dismiss('FDRSVersionPopup');">{{'close'|translate}}</button>
    </div>
  </div>
</ng-template>
<ng-template #VehicleModelMissing let-modal>
  <div class="container version">
    <div class="row popup-header" style="margin-top: 0%;">
      <div class="pull-left">{{'Information'|translate}}</div>
      <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
          (click)="modal.dismiss('VehicleModelMissing')"></i></div>
    </div>
    <div>
      <label class='msg-body'>
        <p>
          {{'VMMissingMsg'|translate}}<br>
          {{'VMMissingMsg1'|translate}}<br>
          {{'VMMissingMsg2'|translate}}
        </p>
      </label>
    </div>

    <hr class="hr-line1">
    <div class="popup-footer">
      <button type="button" class="close-btn-popup pull-right" name="cancel"
        (click)="modal.dismiss('VehicleModelMissing');">{{'close'|translate}}</button>
      <button type="button" class="close-btn-popup pull-right" name="cancel"
        (click)="modal.dismiss('VehicleModelMissing');openGtacLink(content)">{{'Submit'|translate}}</button>
    </div>
  </div>
</ng-template>
<div class="contain-popup">
  <ng-template #content let-modal>
    <div class="forborder">
      <div class="modal-header">
        <i class="fa fa-times mng-qualifier-close-btn" style="margin-left: 450px;"
          (click)="modal.dismiss('Cross click')" title="close">
        </i>
      </div>
      <div class="modal-body">
        <div class="newBorder">
          {{'pleasecontact'|translate}}: wdmoeuhl@msxi.com
        </div>
      </div>
    </div>
  </ng-template>
</div>
<div class="div-border2 spinnerPosition" id="LoadingSpinner">
  <ngx-spinner [fullScreen]="false" bdColor="rgba(0, 0, 0, 0)" color="#003478" size="medium" type="ball-spin-clockwise">
    <p style="font-size: 20px; color: black; margin-top: 50%;">{{'LaunchInfo'|translate}}...</p>
  </ngx-spinner>
</div>
<router-outlet></router-outlet>
